import { LoadingTable, TablePagination } from "SuperAdmin/Components";
import { Button, Space, Table } from "antd";
import { useNavigate } from "react-router-dom";
import styles from "./Table.module.scss";
const TableRoles = ({
  data,
  pagination,
  setPagination,
  filters,
  setFilters,
}) => {
  const navigate = useNavigate();
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (_, record, index) => {
        return (
          <div key={index}>
            <p>{record.name ? record.name : "_"}</p>
          </div>
        );
      },
    },
    {
      title: "Institution",
      dataIndex: "institution_name",
      render: (_, record, index) => {
        return (
          <div key={index}>
            <p>{record.institution_name ? record.institution_name : "_"}</p>
          </div>
        );
      },
    },
    {
      title: "Management scope",
      dataIndex: "management_scope_name",
      key: "management_scope_name",
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (_, record) => {
        return (
          <div
            className={
              record.type == 1
                ? styles["green"]
                : record.type == 2
                ? styles["purple"]
                : styles["gold"]
            }
          >
            {record.type == 1
              ? "Institution"
              : record.type == 2
              ? "Unit"
              : "Personal profile"}
          </div>
        );
      },
      filters: [
        {
          text: "Institution",
          value: "1",
        },
        {
          text: "Unit",
          value: "2",
        },
        {
          text: "Personal profile",
          value: "3",
        },
      ],
      filterMultiple: false,
    },
    {
      title: "Permissions",
      dataIndex: "permissions",
      render: (_, record, index) => {
        return (
          <div key={index}>
            {record.permissions.map((item, i) => (
              <p key={i}>{item}</p>
            ))}
          </div>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => {
              navigate(`/super-admin/roles/${record.id}`, {
                state: {
                  entity_id: record.management_scope_id,
                  entity_type: record.management_scope_name,
                },
              });
            }}
            disabled={record.type === 3}
          >
            Detail
          </Button>
        </Space>
      ),
    },
  ];
  const onChange = (_, filter) => {
    console.log(filter);
    setFilters({ ...filters, type: filter?.type[0] });
  };
  return (
    <div className={styles["table-roles"]}>
      <LoadingTable
        columns={columns}
        rows={pagination.rowsPerPage}
        isLoading={data.isLoading}
        component={
          <Table
            rowKey={(record) => record.id}
            className="table"
            columns={columns}
            dataSource={data.data}
            pagination={{ position: ["none", "none"] }}
            onChange={onChange}
          />
        }
      />
      <TablePagination pagination={pagination} setPagination={setPagination} />
    </div>
  );
};

export default TableRoles;
